import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext"; // ✅ doğru yol

const PrivateRoute = ({ children, izin }) => {
  const auth = useAuth();

  if (!auth) return <div>❌ AuthContext bulunamadı.</div>;

  const { user, role, userPermissions, loading } = auth;

  if (loading) return <div style={{ textAlign: "center", marginTop: 40 }}>Yükleniyor...</div>;
  if (!user || !role) return <Navigate to="/giris" replace />;

  // 🔒 Oluşturucu rolü kontrolü
  if (izin === "olusturucu" && role !== "oluşturucu") {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Yetkisiz Erişim</div>;
  }

  // ✅ Kaza Takip yetki kontrolü
  const kazaIzinleri = userPermissions?.kazatakip || {};
  if (izin !== "olusturucu" && !kazaIzinleri[izin]) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Yetkisiz Erişim</div>;
  }

  return children;
};

export default PrivateRoute;
